import { Injectable, InjectionToken } from '@angular/core';
import { Observable, Scheduler, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as clientDetailsActions from '../actions/client-details';
import { ClientDetailsHttpService } from '../services/client-details-http.service';
import { ClientDetails } from '../models/client-details';
import * as userActions from '../../users/actions/users';

export const SEARCH_DEBOUNCE = new InjectionToken<number>('Search Debounce');
export const SEARCH_SCHEDULER = new InjectionToken<Scheduler>('Search Scheduler');

@Injectable()
export class ClientDetailsEffects {

  constructor(
    private actions$: Actions,
    private clientDetailsHttpService: ClientDetailsHttpService
  ) { }

  
  triggerGet$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<userActions.Load>(userActions.LOAD),
    map(() => new clientDetailsActions.Load())
  ));

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<clientDetailsActions.Load>(clientDetailsActions.LOAD),
    switchMap(() => {
      return this.clientDetailsHttpService.getAllClients().pipe(
        map((clients: ClientDetails[]) => new clientDetailsActions.LoadComplete(clients)),
        catchError(err => of(new clientDetailsActions.LoadError(err)))
      );
    })));

  
  get$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<clientDetailsActions.Get>(clientDetailsActions.GET),
    switchMap((action) => {
      return this.clientDetailsHttpService.getClientDetails(action.clientRef).pipe(
        map((details: ClientDetails) => new clientDetailsActions.GetComplete(details)),
        catchError(err => of(new clientDetailsActions.GetError(err)))
      );
    })));

}
